import { Button, Modal, Typography } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { useSystemStore } from '../stores/SystemStore';

const { Title } = Typography;

const WrapperDiv = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;

	img,
	p,
	button {
		margin: 0.5em;
	}
`;

interface Props {
	isOpened: boolean;
}

const WelcomeSuccessModal: React.FC<Props> = ({ isOpened }) => {
	const setWelcomeSuccessModalVisible = useSystemStore(state => state.setWelcomeSuccessModalVisible);
	return (
		<Modal open={isOpened} footer={null} closable={false}>
			<WrapperDiv>
				<img src="/welcome-success-book.svg" alt="welcome succes" />
				<Title level={3}>Úspěšně jste si nastavili účet v Evidii</Title>
				<p>
					Začněte jednoduše přihlašovat své žáky do výuky a výcviku, na zkoušky a to pomocí pár kliků, bez
					zbytečného opisování stejných záznamů.
				</p>
				<Button size="large" type="primary" onClick={() => setWelcomeSuccessModalVisible(false)}>
					Pokračovat do aplikace
				</Button>
			</WrapperDiv>
		</Modal>
	);
};

export default WelcomeSuccessModal;
